import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { getPredictionv2 } from '../actions/predictions.js'
import { withStyles } from '@material-ui/core/styles'
import InputBase from '@material-ui/core/InputBase'
import LinearProgress from '@material-ui/core/LinearProgress'
import Hidden from '@material-ui/core/Hidden'
import language from '../utils/vast-languagepack'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import Highlighter from "react-highlight-words";
import Button from '@material-ui/core/Button'


const styles = (theme) => ({
	search: {
		position: 'relative',

		backgroundColor: theme.palette.primary.main,
		'&:hover': {
			backgroundColor: theme.palette.primary.main,
		},
		marginRight: 2,
		marginLeft: 0,
		width: '35%',
	},
	searchIcon: {
		width: 10,
		height: '100%',
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	inputRoot: {
		color: 'inherit',
		width: '100%',
	},
	inputInput: {
		padding: 7,
		transition: theme.transitions.create('width'),
		width: '100%',
		maxHeight: 100,
	},
	'& label.Mui-focused': {
		color: 'green',
	},
})

const routes = {
	addMembersToContactGroup: '/contactgroups',
	contactEmailOptOut: '/contacts',
	createContact: '/contacts/new',
	createContactGroup: '/contactgroups',
	createContactGroupWMembers: '/contactgroups',
	uploadContacts: '/contacts/upload',
	deleteContact: '/contacts',
	listContactGroups: '/contactgroups',
	listContacts: '/contacts',
	removeMembersFromContactGroup: '/contactgroups',
	renameContactGroup: '/contactgroups',
	sendEmail: '/tasks/new',
	sendSms: '/tasks/new',
	updateContact: '/contacts',
	viewContact: '/contacts',
	modifyAccountSettings: '/accountSettings',
	listSignupForm: '/forms',
	createSignupForm: '/forms/signup/new',
	createATask: '/tasks/new',
	createACampaign: '/campaigns/new',
	readContactGroupWMembers: '/contactgroups',
}

export default withRouter(
	connect(
		(state) => ({
			lastQuery: state.predictions.lastQuery,
			lastIntent: state.predictions.lastIntent,
			predictions: state.predictions.predictions
		}),
		(dispatch) => bindActionCreators({ getPredictionv2 }, dispatch),
	)(
		withStyles(styles)(
			class SmartRouter extends Component {
				state = {
					typing: false,
					showResults: false
				}
				constructor(props) {
					super(props);
					this.myRef = React.createRef();
				}
				// componentDidMount() {}
				toggleResultsDialog = (show) => {
					this.setState({
						...this.state,
						showResults: show,
						typing:false
					});					
				}
				handleChange = (event) => {
					// console.log(event.keyCode)
					clearTimeout(this.timeout)
					let value = event.target.value

					if (event.keyCode === 13) {
						this.setState({ typing: true })
						this.props.getPredictionv2(value).then(() => {						
							this.toggleResultsDialog(true)
						})
					}
				}
				hanndleResultsClick = (intent) =>{
					this.props.history.push(routes[intent])
				}

				render() {
					const { classes, predictions } = this.props

					const { showResults } = this.state
					const results = predictions?.intents.slice(0,4).map((intent) =>
						<div style={{
							borderBottom: '1px #444 solid',
							padding: '12px 8px',
							color: '#444',
							cursor: 'pointer'
						}} onClick={()=>{this.hanndleResultsClick(intent)}}>{intent.intent}</div>
						)
					const entities = predictions?.entities.map(entity => entity.entity)
					const query = predictions?.query
					return (
						<div
							className={classes.search}
							style={{ width: 'calc(100% - 45px)', display: 'inline-block' }}
							ref={this.myRef}
						>
							<Hidden mdUp>
								<InputBase
									placeholder={language.smartRouter.helperText.command}
									autoComplete={false}
									onKeyUp={this.handleChange}
									classes={{
										root: classes.inputRoot,
										input: classes.inputInput,
									}}
								/>
							</Hidden>
							<Hidden smDown>
								<InputBase
									placeholder={language.smartRouter.helperText.command2}
									autoComplete={false}									
									onKeyUp={this.handleChange}
									classes={{
										root: classes.inputRoot,
										input: classes.inputInput,
									}}
								/>
							</Hidden>
						
							<Dialog
								open={showResults}
								aria-labelledby='responsive-dialog-title'
								style={{ borderRadius: 22 }}
							>
								<DialogContent>
									<h3>Command</h3>

									<Highlighter
										highlightStyle={{ backgroundColor: '#d79300', padding: '3px', borderRadius: '3px'}}
										searchWords={entities}
										autoEscape={true}
										textToHighlight={query}
									/>	

									<h3>A.I. Actions</h3>
									<em>Click an action below to jumpstart your work.</em>

									{results}
								</DialogContent>
								<DialogActions>
								
									<Button
										onClick={() => {
											this.toggleResultsDialog(false);
										}}
										color='secondary'
									>
										close
									</Button>
								</DialogActions>
							</Dialog>

							{this.state.typing ? <LinearProgress color="secondary" /> : null}
						</div>
					)
				}
			},
		),
	),
)
